import { render, staticRenderFns } from "./PreviewArea.vue?vue&type=template&id=137d1bf8&scoped=true&"
import script from "./PreviewArea.vue?vue&type=script&lang=js&"
export * from "./PreviewArea.vue?vue&type=script&lang=js&"
import style0 from "./PreviewArea.vue?vue&type=style&index=0&id=137d1bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d1bf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/circleci/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VSnackbar,VTextarea})
